<template>
  <div>
    <b-navbar class="navbar position-absolute" toggleable="lg">
      <b-navbar-brand href="/"><img class="navbar-brand-img" :src="getLogo" /></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item class="my-auto" @click="$helpers.goToSection('singles-business-block')">{{ $t('openlegal.menu.for-you-and-your-family')}}</b-nav-item>
          <b-nav-item class="my-auto" @click="$helpers.goToSection('companies-block')">{{ $t('openlegal.menu.for-business')}}</b-nav-item>
          <b-nav-item class="my-auto" @click="$helpers.goToSection('freelancers-block')">{{ $t('openlegal.menu.for-freelancers')}}</b-nav-item> -->
          <!-- <b-nav-item class="my-auto nav-lang">
            <lang-selector class="d-inline-block pt-lg-0 pt-3 pb-lg-0 pb-2 mr-0"></lang-selector>
          </b-nav-item>  -->
          <span style="display: contents">
            <!-- <b-nav-item>
              <base-button blue outline @click="() => { signUpVisible = true }"><span>{{ $t('sign-up') }}</span>
              </base-button>
            </b-nav-item>  -->
          <b-nav-item>
              <base-button blue @click="$router.push('/inicio-sesion')"><span>{{ $t('openlegal.menu.sign-in') }}</span>
                <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2"
                  :color="$uiHelpers.isMobile ? ORANGE_COLOUR : 'white'" />
              </base-button>
            </b-nav-item> 
          </span> 
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <openlegal-main-block></openlegal-main-block>
    <openlegal-cards-slider></openlegal-cards-slider>
    <openlegal-for-companies id="companies-block"></openlegal-for-companies>
    <openlegal-for-individuals id="singles-block"></openlegal-for-individuals>
    <!-- <openlegal-for-freelancers id="freelancers-block"></openlegal-for-freelancers> -->
    <openlegal-specialties></openlegal-specialties>
    <b-row id="big-companies" style="min-height:50vh !important"  class="section mx-auto pt-5 pt-sm-0">
        <div class="my-auto text-center">
          <b-col cols="12">
            <h5 class="desktop-fix">
              {{ $t('openlegal.companies') }}
            </h5>
          </b-col>
          <b-col cols="12" class="logos-ctn">
            <b-row class="logos-row">
              <b-col offset-md="1" md="2">
                <img src="/static-appopensalud/img/logos/aon.svg" style="opacity: .5; width: 40%;" alt="AON">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/barcelo.svg" alt="Barcelo">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/IKEA.svg" style="opacity: .5" alt="IKEA">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/msm.svg" style="opacity: .5" alt="Mahou San Miguel">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/mp.png" style="opacity: .5;  width: 40%;"  alt="MP Ascensores">
              </b-col>
            </b-row>
            <b-row class="logos-row mt-lg-5">
              <b-col offset-md="1" md="2">
                <img src="/static-appopensalud/img/logos/siemens.svg" alt="Siemens">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/santander.svg" alt="Santander" style="width: 65%;">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/novo-nordisk.svg" style="opacity: .5" alt="Novo Nordisk">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/IVECO.svg" style="opacity: .5" alt="Iveco">
              </b-col>
              <b-col md="2">
                <img src="/static-appopensalud/img/logos/loreal.svg" alt="L'Oréal" style="opacity: .5">
              </b-col>
            </b-row>
            <!-- <b-row class="logos-row mt-lg-5">
              <b-col md="2" offset-md="4">
                <h2>...</h2>
              </b-col>
            </b-row> -->
          </b-col>
        </div>
      </b-row>
    <companies-contact-form :serviceType="$t('legal-services')" forIndividuals platform="Openlegal" productName="Openlegal" showReason hideEmployeesNumber></companies-contact-form>
  </div>
</template>

<script>
import { BNavbar, BNavbarBrand, BNavbarToggle, BCollapse, BNavbarNav, BNavItem } from 'bootstrap-vue'
import OpenlegalMainBlock from './OpenlegalMainBlock.vue'
import OpenlegalCardsSlider from './OpenlegalCardsSlider.vue'
import OpenlegalForIndividuals from './OpenlegalForIndividuals.vue'
import OpenlegalForCompanies from './OpenlegalForCompanies.vue'
import CompaniesContactForm from '@/components/forms/CompaniesContactForm.vue'
/* import OpenlegalForFreelancers from './OpenlegalForFreelancers.vue' */
import OpenlegalSpecialties from './OpenlegalSpecialties.vue'
import layoutMixin from '@/mixins/layout.mixin'
import { ORANGE_COLOUR } from '@/constants/colours'

export default {
  mixins: [layoutMixin],
  components: {
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItem,
    OpenlegalMainBlock,
    OpenlegalCardsSlider,
    OpenlegalForIndividuals,
    OpenlegalForCompanies,
    CompaniesContactForm,
/*     OpenlegalForFreelancers, */
    OpenlegalSpecialties
  },
	data () {
		return {
			ORANGE_COLOUR
		}
	}
}
</script>

<style lang="scss">
  @import "static-appopensalud/css/public/views/openlegal.scss";
</style>


// WEBPACK FOOTER //
// src/components/views/openlegal/Vertical.vue